import React from "react";

type Props = {
  label: string;
  isActive: boolean;
  onClick: () => void;
  isInactive?: boolean; // クリック自体はできるのでdisabledという命名を使っていない
};

export const ObjectListHeaderToggleButton = ({ label, isActive, onClick, isInactive }: Props) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={
        isActive && !isInactive
          ? "font-bold cursor-default text-[#1c77ff]"
          : "font-normal cursor hover:underline text-[#888888]"
      }
    >
      {label}
    </button>
  );
};
